module.exports = "<span class=\"ordering-widget\">\n  <a href=\"#\" (click)=\"orderingClick($event, 'asc')\" [ngClass]=\"{ selected: checkSelected('asc') }\"><i class=\"fa fa-caret-up\"></i></a>\n  <a href=\"#\" (click)=\"orderingClick($event, 'desc')\" [ngClass]=\"{ selected: checkSelected('desc') }\"><i class=\"fa fa-caret-down\"></i></a>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ordering/ordering.component.html
// module id = ./src/app/common/ordering/ordering.component.html
// module chunks = main